/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".calendar-day{border:1px solid gray;padding:.5rem}.calendar-day-weekend{background-color:#fafaf9;font-style:italic}.calendar-day-content{min-height:5rem}.calendar-alloc-capacity{color:green}.calendar-alloc-over{color:red}"];
export { styles as styles };
